class SlideOutClass {
  constructor(slideOutElement, openButton, closeButton) {
    this.slideOutElement = slideOutElement;
    this.openButton = openButton;
    this.closeButton = closeButton;

    this.openSlideOut = this.openSlideOut.bind(this);
    this.closeSlideOut = this.closeSlideOut.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.openButton.addEventListener("click", this.openSlideOut);
    this.closeButton.addEventListener("click", this.closeSlideOut);
    this.slideOutElement.addEventListener("keydown", this.handleKeyDown);
  }

  openSlideOut() {
    this.slideOutElement.classList.add("active");
    this.slideOutElement.setAttribute("aria-hidden", "false");
    const firstTabbableElement = this.slideOutElement.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (firstTabbableElement) {
      setTimeout(() => {
        firstTabbableElement.focus();
      }, 100); // Adjust the delay as needed
    }
    this.slideOutElement.closest("body").classList.add("overflow-hidden");
  }

  closeSlideOut() {
    this.slideOutElement.classList.remove("active");
    this.slideOutElement.setAttribute("aria-hidden", "true");
    this.openButton.focus();
    this.slideOutElement.closest("body").classList.remove("overflow-hidden");
  }

  handleKeyDown(event) {
    if (event.key === "Escape") {
      this.closeSlideOut();
    }
  }
}
